import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import Accordion from 'utils/accordion';

export default component((node) => {
  const drawerEl = node.querySelector('[data-drawer]');
  const trigger = node.querySelector('[data-trigger]');

  Accordion(node);

  const drawer = Drawer(drawerEl);

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    drawer.open();
  });
});
